import React from 'react';
import PropTypes from 'prop-types';
import { ThemeProvider } from 'styled-components';

import theme from '@theme';
import { StyledNav } from './styled';

const HeaderNav = ({ children }) => (
  <ThemeProvider theme={theme}>
    <StyledNav>{children}</StyledNav>
  </ThemeProvider>
);

HeaderNav.propTypes = {
  children: PropTypes.node.isRequired,
};

export default HeaderNav;
